import { ReactNode } from 'react';
import styled from 'styled-components';

interface DescriptionsProps {
  fullWidth?: boolean;
  children: ReactNode;
  className?: string;
  style?: any;
}

const TableWrapper = styled.table<DescriptionsProps>`
  ${(props) => props.fullWidth && 'width: 100%;'}
  text-align: left;

  tr {
    td {
      padding: 5px 10px;

      &:first-child {
        font-weight: 600;
      }
    }
  }

  .error {
    position: 'relative';
    top: 5px;
  }
`;

const Descriptions: React.FC<DescriptionsProps> = ({
  fullWidth,
  className,
  children,
  style = null,
}) => (
  <TableWrapper className={className} fullWidth={fullWidth} style={style}>
    <tbody>{children}</tbody>
  </TableWrapper>
);

export default Descriptions;
